module.exports = __webpack_public_path__ + "img/img_70.86cdf213.png";